import React, { useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import * as dialogsConfig from 'app-customs/config/dialogsConfig';

// https://mui.com/api/dialog/
export default function DialogMigrate({
  children,
  disableBackdropClick,
  disableEscapeKeyDown,
  onClose,
  open,
  onBackdropClick,
  id,
  className,
  style,
  fullScreen,
}) {
  const isDisableBackdropClick = dialogsConfig.disableBackdropClick
    ? dialogsConfig.disableBackdropClick
    : disableBackdropClick || false;
  const isDisableEscapeKeyDown = dialogsConfig.disableEscapeKeyDown
    ? dialogsConfig.disableEscapeKeyDown
    : disableEscapeKeyDown || false;
  const handleClose = (event, reason) => {
    if (isDisableBackdropClick && reason === 'backdropClick') {
      return false;
    }

    if (isDisableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false;
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  return (
    <Dialog
      id={id}
      className={className}
      fullScreen={fullScreen}
      style={style}
      open={open}
      onBackdropClick={onBackdropClick}
      onClose={handleClose}
    >
      {children}
    </Dialog>
  );
}
